import Accordion from "react-bootstrap/Accordion";
import "./Accordion.style.css";
import React from "react";
import editIcon from "../../assets/images/edit-icon.svg";

interface CustomAccordionProps {
  title: string;
  data: JSX.Element;
  isOpen: boolean;
  toggleAccordion: () => void;
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  data,
  isOpen,
  toggleAccordion,
}) => {
  return (
    <Accordion activeKey={isOpen ? "0" : undefined}>
      <Accordion.Item eventKey="0">
        <Accordion.Header onClick={toggleAccordion}>
          <div className="accordion-header-content">
            <img src={editIcon} alt="Edit Icon" className="accordion-icon" />
            <span>{title}</span>
          </div>
        </Accordion.Header>
        <Accordion.Body>{data}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CustomAccordion;
